module.exports = __webpack_public_path__ + "img/UY.31bef519.svg";